import clsx from 'clsx';
import React, { ReactNode, RefObject } from 'react';

import { PinConfig } from '../table-cell/TableCell';
import { TableHeader, TableHeaderProps } from '../table-header/TableHeader';
import styles from './StickyTableHeader.module.scss';

export interface StickyTableHeaderProps extends TableHeaderProps {
  size?: number;
  pinConfig?: PinConfig;
  children: ReactNode;
}

export const StickyTableHeader = React.forwardRef(
  (
    {
      pinConfig,
      size,
      children,
      isSorted,
      isSortable,
      className,
      ...rest
    }: StickyTableHeaderProps,
    forwardRef
  ) => {
    return (
      <TableHeader
        className={clsx(styles.stickyHeader, className, {
          [styles.pinned]: !!pinConfig,
          [styles.lastPinned]: !!pinConfig?.isLastPinned,
        })}
        style={{
          ...(size && { width: `${size}px` }),
          ...(pinConfig && {
            left: `${pinConfig.left}px`,
            right: `${pinConfig.right}px`,
          }),
        }}
        isSortable={isSortable}
        isSorted={isSorted}
        {...rest}
        ref={forwardRef as RefObject<HTMLTableCellElement>}
      >
        <div
          className={styles.contentContainer}
          style={size ? { width: `${size - 24}px` } : undefined}
        >
          {children}
        </div>
      </TableHeader>
    );
  }
);
